window.gmtrans = function(string, parameters, locale) {
    locale = window.greenmotion.isUsa ? 'en-us' : locale;
    
    try {
      let prefix = 'greenmotion.';
      let localised = Lang.get(prefix + string, parameters, locale);

      if (localised.substr(prefix.length) === string && localised.substr(0, prefix.length) === prefix) {
          return Lang.get(string, parameters, locale);
      }

      if (localised === prefix + string) {
          return Lang.get(prefix + string, parameters, 'en');
      }

      return localised;
    } catch (exception) {
      console.error(exception);
    }

    return string;
}
